import { http } from '@/utils/http' // eslint-disable-line

export default {
  async loadSCMFields (campaignIds) {
    const scmFields = {}
    await Promise.all(campaignIds.map(campaignId => new Promise((resolve, reject) => {
      http.st.get(`/campaigns/${campaignId}/scm-fields/`).then((res) => {
        scmFields[campaignId] = res.data
          .filter(field => !field['is_archived'])
          .map(field => ({
            key: field['key'],
            label: field['name'],
            type: field['type'],
            required: field['is_required'],
            immutable: ['transaction_id', 'transaction_id_internal'].includes(field['key'])
          }))
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })))
    return scmFields
  }
}
